import { useAuthStore } from '~/stores/useAuthStore';
import { getActivePinia } from 'pinia';

// middleware/password-change-check.global.ts
// 비밀번호 변경이 필요한 사용자를 비밀번호 변경 페이지로 리다이렉트
export default defineNuxtRouteMiddleware(async to => {
  // ⭐ Pinia가 아직 초기화되지 않았으면 스킵 (첫 로드 시)
  if (!getActivePinia()) {
    return;
  }

  const auth = useAuthStore();

  // 비밀번호 변경 페이지 경로 (웹/모바일 분기)
  // 참고: to.path는 base URL을 제외한 경로 (router.options.ts에서 /screens/* → /* 변환됨)
  const isMobile = to.path.startsWith('/mobile');
  // router.options.ts에서 /screens/* → /* 변환하므로 /screens 없이 직접 지정
  // navigateTo는 router.resolve()를 사용하므로 path로 지정해야 alias가 아닌 main path 사용
  const passwordChangePath = isMobile
    ? { path: '/mobile/password-change' }
    : { path: '/screens/common/config/password-change/password-change' };

  // 모바일은 페이지에서 직접 체크 (미들웨어 제외)
  if (isMobile) {
    return;
  }

  // 체크에서 제외할 페이지들
  const excludedRoutes = [
    '/login',
    '/login.do',
    '/common/config/password-change/password-change',
    '/screens/common/config/password-change/password-change', // alias
  ];

  // 제외 경로면 체크하지 않음
  if (excludedRoutes.includes(to.path)) {
    return;
  }

  // 로그인되지 않은 경우 체크하지 않음
  if (!auth.isLoggedIn) {
    return;
  }

  // 사용자 정보가 있는 경우에만 체크
  // 비밀번호 변경이 필요한 경우 비밀번호 변경 페이지로 리다이렉트
  // - alertPwChangeYn === 'Y': 주기 도래 알림 (연장 가능)
  // - pwInitYn === 'Y': 반드시 비밀번호 변경 필요 (연장 불가)
  if (auth.user && auth.user.authMethod === 'password') {
    if (auth.user.pwInitYn === 'Y' || auth.user.alertPwChangeYn === 'Y') {
      // 비밀번호 변경 완료 직후인 경우 리다이렉트 스킵
      if (process.client) {
        const passwordChangeCompleted = sessionStorage.getItem('passwordChangeCompleted');
        if (passwordChangeCompleted === 'true') {
          // 플래그 제거하고 스토어 상태도 업데이트
          sessionStorage.removeItem('passwordChangeCompleted');
          auth.user.pwInitYn = 'N';
          auth.user.alertPwChangeYn = 'N';
          return;
        }

        // 원래 접근하려던 페이지를 저장 (비밀번호 변경 후 복귀용)
        sessionStorage.setItem('passwordChangeRedirectPath', to.fullPath);
      }
      return navigateTo(passwordChangePath);
    }
  }
});
